import { createElementFromHTML, getSubscriptionDefitionNode, getTranslatedDefinition, setSubscriptionIdsNode } from '../utils/common';
import { DOM_IDS } from '../utils/constants';
export default function loadSubscriptionDefinitions({
  subscriptionStatuses,
  sentSubscriptionId
}) {
  if (!subscriptionStatuses || subscriptionStatuses && subscriptionStatuses.length === 0) {
    return;
  }
  const definitionNodes = [];
  const subscriptionIds = [];
  for (const subscriptionStatus of subscriptionStatuses) {
    if (!subscriptionStatus.translations) {
      continue;
    }
    const subscriptionDefinition = getTranslatedDefinition(subscriptionStatus);
    const subscriptionNode = getSubscriptionDefitionNode({
      subscribed: subscriptionStatus.checkboxChecked,
      name: subscriptionDefinition.name,
      description: subscriptionDefinition.description,
      category: subscriptionDefinition.process,
      channel: subscriptionDefinition.operation,
      id: subscriptionStatus.id
    }, sentSubscriptionId);
    subscriptionIds.push(subscriptionStatus.id);
    const itemClass = ['item'];
    const subscriptionElement = `
      <div class="${itemClass.join(' ')}">
        ${subscriptionNode}
      </div>
    `;
    definitionNodes.push(createElementFromHTML(subscriptionElement));
  }
  setSubscriptionIdsNode(subscriptionIds.join(','));
  const subscriptionDefinitionDOMElement = document.getElementById(DOM_IDS.subscriptionsDefinitions);
  subscriptionDefinitionDOMElement && subscriptionDefinitionDOMElement.replaceWith(...definitionNodes);
}